/**
 * @author        luis.orihuela@zumper.com (Luis Orihuela)
 * @copyright     Copyright (c) 2025, Zumper
 */

import { StreamToken } from '@zcode/bizos'
import { alwaysReducer, falseReducer, payloadReducer, trueReducer } from '@zcode/reducers'
import type { Messages } from '@zcode/state-type'
import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'
import {
  CLEAR_STREAM_TOKEN,
  RECEIVE_STREAM_CONVERSATIONS_DATA,
  RECEIVE_STREAM_TOKEN_DATA,
  RECEIVE_STREAM_TOKEN_RETRY,
  SET_FEATURE_NOT_ENABLED,
  SET_STREAM_TOKEN_ERROR,
} from '../constants'
import type { ActionTypes } from '../types'

export const streamToken = combineReducers<Messages['streamToken'], ActionTypes>({
  data: handleActions<Messages['streamToken']['data'], ActionTypes>(
    {
      [CLEAR_STREAM_TOKEN]: (state) => {
        if (state) {
          return new StreamToken({
            api_key: state.apiKey,
            stream_id: state.streamId,
            token: undefined,
          })
        }
        return null
      },
      [RECEIVE_STREAM_TOKEN_DATA]: (state, { payload }) => {
        return payload
      },
      [RECEIVE_STREAM_CONVERSATIONS_DATA]: (state, { payload }) => {
        return payload.data.streamToken
      },
    },
    null
  ),
  featureNotEnabled: handleActions<Messages['streamToken']['featureNotEnabled'], ActionTypes>(
    {
      [SET_FEATURE_NOT_ENABLED]: trueReducer,
      [RECEIVE_STREAM_TOKEN_DATA]: falseReducer,
    },
    false
  ),
  isError: handleActions<Messages['streamToken']['isError'], ActionTypes>(
    {
      [SET_STREAM_TOKEN_ERROR]: trueReducer,
      [RECEIVE_STREAM_TOKEN_DATA]: falseReducer,
    },
    false
  ),
  retryAfter: handleActions<Messages['streamToken']['retryAfter'], ActionTypes>(
    {
      [RECEIVE_STREAM_TOKEN_RETRY]: payloadReducer,
      [RECEIVE_STREAM_TOKEN_DATA]: alwaysReducer(null),
    },
    null
  ),
})
